// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let WizardFormValidation = require("../wizard/WizardFormValidation.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay__Validators__KeyFacts__Price = require("./PropertyWizardFormRelay__Validators__KeyFacts__Price.bs.js");
let PropertyWizardFormRelay__Validators__KeyFacts__Address = require("./PropertyWizardFormRelay__Validators__KeyFacts__Address.bs.js");
let PropertyWizardFormRelayValidatorsKeyFacts_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFacts_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFacts_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFacts_formState_graphql.bs.js");
let PropertyWizardFormRelay__Validators__KeyFacts__PropertyType = require("./PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.bs.js");

let SubFields = {
  Address: undefined,
  Price: undefined,
  PropertyType: undefined
};

let convertFragment = PropertyWizardFormRelayValidatorsKeyFacts_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFacts_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFacts_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFacts_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFacts_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardFormRelayValidatorsKeyFacts_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFacts_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFacts_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFacts_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFacts_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function use$2(draft, formState) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFacts_draft_graphql.node, convertFragment, draft);
  let formState$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFacts_formState_graphql.node, convertFragment$1, formState);
  let priceIsValid = PropertyWizardFormRelay__Validators__KeyFacts__Price.useIsValid(draft$1.fragmentRefs);
  let propertyTypeIsValid = PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.useIsValid(draft$1.fragmentRefs);
  let addressIsValid = PropertyWizardFormRelay__Validators__KeyFacts__Address.useIsValid(draft$1.fragmentRefs, formState$1.fragmentRefs);
  return WizardFormValidation.allSubStepsValid([
    priceIsValid,
    propertyTypeIsValid,
    addressIsValid
  ]);
}

exports.SubFields = SubFields;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.use = use$2;
/* WizardFormValidation Not a pure module */
